<template>
  <div class="bg">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>科普宣教库</el-breadcrumb-item>
      <el-breadcrumb-item>{{ isEditMode ? '编辑文章' : '添加文章' }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container">

      <div style="width:900px">

        <div class="category-section-top">
          <h5>分类绑定</h5>
          <el-tabs v-model="activeTab">
            <el-tab-pane label="入院宣教" name="ruyuan">
              <el-cascader
                v-model="ruyuanCategory"
                :options="ruyuanCategoryOptions"
                placeholder="选择分类"
                @change="ruyuanCategoryChange"
                style="width: 100%; margin-bottom: 10px;"
              ></el-cascader>
              <el-checkbox-group v-model="ruyuanCheckList">
                <el-checkbox
                  v-for="item in ruyuanCheckOptions"
                  :key="item.id"
                  :label="item.name"
                ></el-checkbox>
              </el-checkbox-group>
            </el-tab-pane>
            <el-tab-pane label="机器人宣教" name="robot">
              <el-cascader
                v-model="robotCategory"
                :options="robotCategoryOptions"
                placeholder="选择分类"
                @change="robotCategoryChange"
                style="width: 100%; margin-bottom: 10px;"
              ></el-cascader>
              <el-checkbox-group v-model="robotCheckList">
                <el-checkbox
                  v-for="item in robotCheckOptions"
                  :key="item.id"
                  :label="item.name"
                ></el-checkbox>
              </el-checkbox-group>
            </el-tab-pane>
          </el-tabs>

          <el-divider content-position="left">文章可见范围（可选）</el-divider>
          <p class="scope-hint">选择医院科室后，该文章仅对指定范围可见；不配置则默认全局可见</p>
          <el-table
            :data="scopeListToAdd"
            border
            size="small"
            style="width: 100%; margin-bottom: 12px"
            empty-text="未配置（默认全局可见）"
          >
            <el-table-column label="医院" prop="hospitalName">
              <template slot-scope="scope">
                {{ scope.row.hospitalName || '（全局）' }}
              </template>
            </el-table-column>
            <el-table-column label="科室" prop="departmentName">
              <template slot-scope="scope">
                {{ scope.row.departmentName || '（不限科室）' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  style="color:#F56C6C"
                  @click="removeScopeToAdd(scope.$index)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form :inline="true" size="small">
            <el-form-item label="医院">
              <el-select
                v-model="scopeForm.hospitalName"
                placeholder="请选择医院"
                clearable
                style="width:180px"
                @change="onScopeHospitalChange"
              >
                <el-option
                  v-for="item in scopeHospitalOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="科室">
              <el-select
                v-model="scopeForm.departmentName"
                placeholder="请选择科室"
                clearable
                :disabled="!scopeForm.hospitalName"
                style="width:180px"
              >
                <el-option
                  v-for="item in scopeDepartmentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="addScopeToAdd">添加</el-button>
            </el-form-item>
          </el-form>
        </div>

        <p>标题</p>
        <el-input
          v-model="article.title"
          placeholder="请输入标题"
        ></el-input>

        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="6">
            <div>
              <p>作者</p>
              <el-input
                style="width:200px"
                v-model="article.author"
                placeholder="请输入作者"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="18">
            <div>
              <p>引用网页</p>
              <el-input
                v-model="article.refLink"
                placeholder="请输入文章网址"
              ></el-input>
            </div>
          </el-col>

        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="6">
            <el-button type="primary" @click="onSelectArticle" style="margin-bottom: 10px;">选择文章/视频</el-button>
            <el-button type="success" @click="onSelectWordFile" style="margin-bottom: 10px; margin-left: 10px;">导入Word文档</el-button>
            <el-button type="warning" @click="onSelectBatchWordFiles" style="margin-bottom: 10px; margin-left: 10px;">批量导入Word</el-button>
            <input ref="wordFileInput" type="file" accept=".docx" style="display: none" @change="onWordFileChange" />
            <input ref="batchWordFileInput" type="file" accept=".docx" multiple style="display: none" @change="onBatchWordFileChange" />
            <template v-if="article.title" >
              <div style="display:inline-block;vertical-align:middle;min-width:600px;">
                <el-table :data="[article]" border style="width:auto;min-width:600px;max-width:900px;font-size:12px;">
                  <el-table-column prop="title" label="标题" min-width="120"></el-table-column>
                  <el-table-column prop="contentType" label="类型" min-width="60">
                    <template slot-scope="scope">
                      <span v-if="scope.row.contentType === 1">文章</span>
                      <span v-else-if="scope.row.contentType === 2">视频</span>
                      <span v-else-if="scope.row.contentType === 3">录入</span>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="source" label="来源" min-width="80"></el-table-column>
                  <el-table-column v-if="article.contentType === 2" prop="videoUrl" label="视频URL" min-width="180">
                    <template slot-scope="scope">
                      <a v-if="scope.row.videoUrl" :href="scope.row.videoUrl" target="_blank" style="color:#409EFF;word-break:break-all;">{{ scope.row.videoUrl }}</a>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="article.contentType === 2 && article.videoCourseId" prop="videoCourseId" label="courseId" min-width="80"></el-table-column>
                  <el-table-column prop="refLink" label="引用页面" min-width="180">
                    <template slot-scope="scope">
                      <a v-if="scope.row.refLink" :href="scope.row.refLink" target="_blank" style="color:#409EFF;word-break:break-all;">{{ scope.row.refLink }}</a>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="brief" label="摘要" min-width="120"></el-table-column>
                </el-table>
              </div>
            </template>
          </el-col>
        </el-row>

      </div>

      <div class="content-layout">
        <div class="editor-wrapper">
          <quill-editor
            class="editor"
            v-model="article.content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
            @change="onEditorChange"
          >
          </quill-editor>
        </div>

        <div class="right-panel">
          <div class="brief-section">
            <h5><span style="color:red;">*</span> 摘要</h5>
            <el-input
              type="textarea"
              class="brief-input"
              :autosize="{ minRows: 4}"
              placeholder="请输入[摘要]"
              v-model="article.brief"
            >
            </el-input>
          </div>

          <div class="robot-script-section">
            <h5>机器人播报文案</h5>
            <el-input
              type="textarea"
              class="robot-script-input"
              placeholder="请输入机器人播报文案"
              v-model="article.robotScript"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="batch-import-section">
        <div class="section-header">
          <h5>批量导入文章（JSON）</h5>
          <span class="section-hint">支持批量导入药物信息文章，需先选择分类</span>
        </div>

        <input
          ref="jsonFileInput"
          type="file"
          accept=".json"
          style="display: none"
          @change="onJsonFileChange"
        />

        <div class="batch-import-controls">
          <div class="control-row">
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-folder-opened"
              @click="onSelectJsonFile"
              :disabled="batchImporting"
            >选择 JSON 文件</el-button>

            <div v-if="jsonFileName" class="file-info-box">
              <i class="el-icon-document"></i>
              <span class="file-name">{{ jsonFileName }}</span>
              <el-tag size="small" type="success">{{ jsonImportData ? jsonImportData.length : 0 }} 条</el-tag>
            </div>
          </div>

          <div v-if="jsonImportData && jsonImportData.length > 0" class="control-row">
            <el-button
              size="medium"
              type="success"
              icon="el-icon-upload2"
              @click="onBatchImport"
              :loading="batchImporting"
            >{{ batchImporting ? '导入中...' : '开始批量导入' }}</el-button>
          </div>
        </div>

        <div v-if="batchImporting" class="batch-progress">
          <el-progress
            :percentage="Math.round((batchProgress.current / batchProgress.total) * 100)"
            :status="batchProgress.fail > 0 ? 'warning' : ''"
          ></el-progress>
          <div class="progress-info">
            <span>正在导入：{{ batchProgress.current }}/{{ batchProgress.total }}</span>
            <span class="progress-detail">
              <span class="success-count">成功 {{ batchProgress.success }}</span>
              <span class="fail-count">失败 {{ batchProgress.fail }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="batch-import-section">
        <div class="section-header">
          <h5>批量导入文章（Word）</h5>
          <span class="section-hint">支持批量导入 Word 文档，需先选择分类</span>
        </div>

        <div class="batch-import-controls">
          <div class="control-row">
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-folder-opened"
              @click="onSelectBatchWordFiles"
              :disabled="batchWordImporting"
            >选择 Word 文件</el-button>

            <div v-if="batchWordFiles.length > 0" class="file-info-box">
              <i class="el-icon-document"></i>
              <span class="file-name">已选择 {{ batchWordFiles.length }} 个文件</span>
            </div>
          </div>

          <div v-if="batchWordFiles.length > 0" class="control-row">
            <el-button
              size="medium"
              type="success"
              icon="el-icon-upload2"
              @click="onBatchWordImport"
              :loading="batchWordImporting"
            >{{ batchWordImporting ? '导入中...' : '开始批量导入' }}</el-button>
          </div>
        </div>

        <div v-if="batchWordImporting" class="batch-progress">
          <el-progress
            :percentage="Math.round((batchWordProgress.current / batchWordProgress.total) * 100)"
            :status="batchWordProgress.fail > 0 ? 'warning' : ''"
          ></el-progress>
          <div class="progress-info">
            <span>正在导入：{{ batchWordProgress.current }}/{{ batchWordProgress.total }}</span>
            <span class="progress-detail">
              <span class="success-count">成功 {{ batchWordProgress.success }}</span>
              <span class="fail-count">失败 {{ batchWordProgress.fail }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="submit-section">
        <el-button
          size="medium"
          type="success"
          icon="el-icon-check"
          @click="onArticleSubmit"
          :disabled="batchImporting || batchWordImporting"
        >{{ isEditMode ? '保存修改' : '提交单篇文章' }}</el-button>
      </div>

    </div>

    <el-dialog
      title="选择文章/视频"
      :visible.sync="selectDialogVisible"
      width="80vw"
      @close="searchKeyword = ''; searchResults = []; selectedItem = null; searched = false; filterType = 'all'"
    >
      <div style="margin-bottom: 16px; display: flex; align-items: center;">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入标题关键词"
          style="width: 300px; margin-right: 12px;"
          @keyup.enter.native="onSearchArticle"
        />
        <el-button type="primary" :loading="searchLoading" @click="onSearchArticle">搜索</el-button>
        <el-radio-group v-model="filterType" size="small" style="margin-left: 24px;">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="krq_article">康复圈文章</el-radio-button>
          <el-radio-button label="krq_video">康复圈视频</el-radio-button>
          <el-radio-button label="course_video">视频库</el-radio-button>
        </el-radio-group>
      </div>
      <el-table
        v-if="filterResults.length > 0"
        :data="filterResults"
        style="width: 100%; margin-bottom: 12px;"
        highlight-current-row
        @current-change="selectedItem = $event"
        :row-key="row => row.id"
        max-height="500"
      >
        <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
        <el-table-column prop="type" label="类型" min-width="80"></el-table-column>
        <el-table-column prop="source" label="来源" min-width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140"></el-table-column>
        <el-table-column prop="brief" label="摘要" min-width="200">
          <template #default="{ row }">
        <el-tooltip :content="row.brief" placement="top" popper-class="long-text-tooltip" :disabled="!isEllipsisActive(row.brief)">
          <div class="ellipsis-text" ref="ellipsisText">{{ row.brief }}</div>
        </el-tooltip>
      </template>
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onSelectResult(scope.row)">选择</el-button>
            <el-button type="text" size="small" @click="onPreview(scope.row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="!searchLoading && searchKeyword && searched">暂无搜索结果</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 预览弹窗，模拟手机比例375x667 -->
    <el-dialog
      :visible.sync="previewVisible"
      :title="previewTitle"
      width="375px"
      custom-class="mobile-preview-dialog"
      :close-on-click-modal="false"
      @close="onPreviewClose"
    >
      <div style="width: 100%; height: 667px; overflow-y: auto; background: #f7f7f7;">
        <template v-if="previewType === 'video'">
          <video
            :src="previewVideoUrl"
            controls
            style="width: 100%; height: auto; max-height: 100%; background: #000; border-radius: 8px;"
          ></video>
        </template>
        <template v-else-if="previewType === 'article'">
          <div style="width: 100%; padding: 16px; background: #fff; border-radius: 8px; min-height: 200px;">
            <div v-html="previewContent"></div>
          </div>
        </template>
        <template v-else>
          暂不支持预览
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭预览</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { Quill, quillEditor } from 'vue-quill-editor'
import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
import ImageResize from 'quill-image-resize-module'
import { uploadFile } from '@/utils/AliOssUploadUtils'

Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/ImageResize', ImageResize)

const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// quill编辑器的字体
// var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var fonts = ['SimSun']
var Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)

const ARTICLE_UPLOAD_CACHE_KEY = 'article_upload_cached_selection'

export default {
  components: { quillEditor },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      activeTab: 'ruyuan',
      ruyuanCategory: [],
      ruyuanCategoryOptions: [],
      ruyuanCheckOptions: [],
      ruyuanCheckList: [],
      robotCategory: [],
      robotCategoryOptions: [],
      robotCheckOptions: [],
      robotCheckList: [],
      editorOption: {
        // some quill options
        theme: 'snow',
        modules: {
          ImageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          },
          // ImageResize: {
          //   modules: ['Resize', 'DisplaySize', 'Toolbar']
          // },
          ImageExtend: {
            loading: true,
            name: 'file',
            action: '',
            customUpload: (file, insert) => {
              uploadFile(
                'article/img',
                file,
                percent => {
                  console.log('上传进度:', percent)
                },
                fileUrl => {
                  insert(fileUrl)
                },
                error => {
                  console.error('上传失败', error)
                  this.$message.error('图片上传失败')
                }
              )
            }
          },
          toolbar: {
            container: [
              [{ header: 2 },
                'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', { list: 'ordered' }, { list: 'bullet' }], // 标题，键值对的形式；1、2表示字体大小 ：： [{ header: 1 }, { header: 2 }]
              // ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              // ['blockquote', 'code-block'], // 引用，代码块
              // [{ list: 'ordered' }, { list: 'bullet' }], // 列表
              // [{ script: 'sub' }, { script: 'super' }], // 上下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              // [{ direction: 'rtl' }], // 文本方向
              [{ size: Size.whitelist }], // 字体大小
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ font: Font.whitelist }], // 字体
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ],
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      article: {
        title: '',
        author: '动优科技',
        refLink: '',
        content: '',
        brief: '',
        robotScript: ''
        // contentType、videoUrl、videoCourseId 动态添加
      },
      // 选择文章/视频弹窗相关数据
      selectDialogVisible: false, // 弹窗显示状态
      searchKeyword: '', // 搜索关键词
      searchLoading: false, // 搜索加载状态
      searchResults: [], // 搜索结果列表
      selectedItem: null, // 选中的文章/视频项
      // 预览相关
      previewVisible: false, // 预览弹窗显示状态
      previewType: '', // 预览类型：video/article
      previewTitle: '', // 预览标题
      previewContent: '', // 文章内容
      previewVideoUrl: '', // 视频地址
      searched: false, // 是否已点击过搜索
      filterType: 'all', // 新增：筛选类型，默认全部
      // 批量导入相关
      jsonImportData: null, // 解析后的 JSON 数据
      jsonFileName: '', // 文件名
      batchImporting: false, // 是否正在批量导入
      batchProgress: { current: 0, total: 0, success: 0, fail: 0 }, // 批量导入进度
      // 批量Word导入相关
      batchWordFiles: [], // 批量Word文件列表
      batchWordImporting: false, // 是否正在批量导入Word
      batchWordProgress: { current: 0, total: 0, success: 0, fail: 0 }, // 批量Word导入进度
      // 文章可见范围（添加页）
      scopeListToAdd: [],
      scopeForm: { hospitalName: '', departmentName: '' },
      scopeHospitalOptions: [],
      scopeDepartmentOptions: [],
      scopeDepartmentsByHospital: {}
    }
  },
  methods: {
    isEllipsisActive (text) {
      // 这里可以添加更精确的判断逻辑
      return text && text.length > 50 // 假设50个字符以上会超出
    },
    onEditorBlur (quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)

      quill.root.addEventListener('paste', async (e) => {
        const clipboardData = e.clipboardData
        if (!clipboardData || !clipboardData.items) return

        for (let i = 0; i < clipboardData.items.length; i++) {
          const item = clipboardData.items[i]
          if (item.type.indexOf('image') !== -1) {
            e.preventDefault()

            const file = item.getAsFile()
            if (!file) continue

            const range = quill.getSelection(true)
            quill.insertEmbed(range.index, 'image', 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7')
            quill.setSelection(range.index + 1)

            uploadFile(
              'article/img',
              file,
              percent => {
                console.log('粘贴图片上传进度:', percent)
              },
              fileUrl => {
                const currentRange = quill.getSelection()
                if (currentRange) {
                  quill.deleteText(range.index, 1)
                  quill.insertEmbed(range.index, 'image', fileUrl)
                  quill.setSelection(range.index + 1)
                }
              },
              error => {
                console.error('粘贴图片上传失败', error)
                this.$message.error('粘贴图片上传失败')
                quill.deleteText(range.index, 1)
              }
            )

            break
          }
        }
      })
    },
    onEditorChange ({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)

      this.article.content = html
      console.log('文章内容', this.article.content)
    },
    onArticleSubmit () {
      if (this.isEditMode) {
        this.updateArticle()
      } else {
        this.postArticle()
      }
    },
    onSelectArticle () {
      // 打开选择文章/视频弹窗
      this.selectDialogVisible = true
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedItem = null
      this.searched = false // 重置搜索状态
    },
    async onSearchArticle () {
      if (!this.searchKeyword) {
        this.$message.warning('请输入要搜索的标题关键词')
        return
      }
      this.searchLoading = true
      this.searched = true // 标记已搜索
      try {
        // 按接口文档，GET /content/search?keyWord=xxx
        const resp = await this.$http.get('/content/search', { params: { keyWord: this.searchKeyword } })
        const res = resp.data
        console.log(res)
        if (res.code === 0 || res.code === 200) {
          // 合并两类内容，统一格式
          const articles = (res.data.rehabilitationCircleContent || []).map(item => ({
            id: item.id,
            title: item.title,
            author: item.userId || '-',
            type: item.type === 1 ? '文章' : item.type === 2 ? '图片' : item.type === 3 ? '视频' : '-',
            brief: item.summary || '',
            content: item.content || '',
            refLink: '',
            raw: item,
            source: '康复圈',
            createTime: this.formatDate(item.gmtCreate)
          }))
          const courses = (res.data.course || []).map(item => ({
            id: item.courseId,
            title: item.title,
            author: '-', // 课程无作者字段
            type: '视频',
            brief: item.brief || '',
            content: item.text || '',
            refLink: '',
            raw: item,
            source: '训练库',
            createTime: this.formatDate(item.createDate)
          }))
          this.searchResults = [...articles, ...courses]
        } else {
          this.$message.error(res.message || '搜索失败')
          console.log('接口异常返回：', res)
        }
      } catch (e) {
        this.$message.error('搜索请求异常')
      } finally {
        this.searchLoading = false
      }
    },
    onSelectResult (item) {
      // 选中某一项，回填表单
      this.article.title = item.title || ''
      this.article.author = item.author || ''
      this.article.source = item.source || ''
      // 如果是文章，自动设置引用页面链接
      if (item.type === '文章' && item.id) {
        this.article.refLink = `https://doucan.jianerkanggz.cn/#/feeds/detail/${item.id}?hideNavBar=true`
        this.article.content = item.content || ''
        this.article.contentType = 1
        // 移除视频相关字段
        delete this.article.videoUrl
        delete this.article.videoCourseId
      } else if (item.type === '视频') {
        // 视频类型
        // 训练库视频：videoUrl，康复圈视频：video
        let url = ''
        if (item.source === '训练库') {
          url = item.raw && item.raw.videoUrl
          this.article.videoCourseId = item.raw && item.raw.courseId
        } else if (item.source === '康复圈') {
          url = item.raw && item.raw.video
          delete this.article.videoCourseId
        } else {
          delete this.article.videoCourseId
        }
        this.article.videoUrl = this.fixVideoUrl(url || '')
        this.article.refLink = item.refLink || ''
        this.article.content = item.title || ''
        this.article.contentType = 2
      } else {
        this.article.refLink = item.refLink || ''
        this.article.content = item.content || ''
        delete this.article.videoUrl
        delete this.article.videoCourseId
        delete this.article.contentType
      }
      // 如果内容没有摘要，则用标题作为摘要，保证页面摘要输入框有值
      this.article.brief = item.brief || item.title || ''
      this.selectDialogVisible = false
      this.$message.success('已选择文章/视频')
    },
    async postArticle () {
      if (!this.article.brief) {
        this.article.brief = this.article.title || ''
      }
      // 录入的文章（非选择文章/视频）类型 = 3
      if (this.article.contentType === undefined || this.article.contentType === null) {
        this.article.contentType = 3
      }
      console.log(this.article)
      const { data: resp } = await this.$http.post('cms/article/add', this.article)
      console.log(resp)
      if (resp.code === 200) {
        const articleId = resp.data.id
        await this.bindCategoryAndTags(articleId)
        await this.bindArticleScopes(articleId)
        await this.setArticleActive(articleId)
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.resetForm()
      } else {
        this.$message.error(resp.message)
      }
    },
    async updateArticle () {
      if (!this.article.brief) {
        this.article.brief = this.article.title || ''
      }
      const { data: resp } = await this.$http.put('cms/article/update', this.article, {
        params: { id: this.id }
      })
      if (resp.code === 200) {
        this.$message.success('修改成功！')
        this.$router.push('/menu/content/article')
      } else {
        this.$message.error(resp.message)
      }
    },
    async loadArticleForEdit (articleId) {
      const { data: resp } = await this.$http.get('cms/article/load', {
        params: { id: articleId }
      })
      if (resp.code !== 200) {
        this.$message.error(resp.message || '加载文章失败')
        return
      }
      const data = resp.data
      this.article.title = data.title || ''
      this.article.author = data.author || ''
      this.article.refLink = data.refLink || ''
      this.article.content = data.content || ''
      this.article.brief = data.brief || ''
      this.article.robotScript = data.robotScript || ''
      if (data.contentType) this.article.contentType = data.contentType
      if (data.videoUrl) this.article.videoUrl = data.videoUrl
      if (data.videoCourseId) this.article.videoCourseId = data.videoCourseId

      this.$nextTick(() => {
        if (this.$refs.myQuillEditor && this.$refs.myQuillEditor.quill) {
          this.$refs.myQuillEditor.quill.root.innerHTML = data.content || ''
        }
      })

      if (data.scopeList && data.scopeList.length > 0) {
        this.scopeListToAdd = data.scopeList.map(s => ({
          hospitalName: s.hospitalName || null,
          departmentName: s.departmentName || null
        }))
      }
    },
    resetForm () {
      this.article = {
        title: '',
        author: '动优科技',
        refLink: '',
        content: '',
        brief: '',
        robotScript: ''
      }
      // 保留宣教分类、可见范围、医院科室选择，便于连续为同一科室添加文章
      if (this.$refs.myQuillEditor) {
        this.$refs.myQuillEditor.quill.setText('')
      }
    },
    saveArticleUploadCache () {
      if (this.isEditMode) return
      try {
        let scopeFormToSave = {
          hospitalName: this.scopeForm?.hospitalName || null,
          departmentName: this.scopeForm?.departmentName || null
        }
        if ((!scopeFormToSave.hospitalName && !scopeFormToSave.departmentName) &&
            this.scopeListToAdd?.length > 0) {
          const last = this.scopeListToAdd[this.scopeListToAdd.length - 1]
          scopeFormToSave = {
            hospitalName: last.hospitalName || null,
            departmentName: last.departmentName || null
          }
        }
        const cache = {
          activeTab: this.activeTab,
          ruyuanCategory: [...(this.ruyuanCategory || [])],
          robotCategory: [...(this.robotCategory || [])],
          ruyuanCheckList: [...(this.ruyuanCheckList || [])],
          robotCheckList: [...(this.robotCheckList || [])],
          scopeListToAdd: (this.scopeListToAdd || []).map(s => ({
            hospitalName: s.hospitalName || null,
            departmentName: s.departmentName || null
          })),
          scopeForm: scopeFormToSave
        }
        localStorage.setItem(ARTICLE_UPLOAD_CACHE_KEY, JSON.stringify(cache))
      } catch (e) {
        console.warn('保存宣教选择缓存失败', e)
      }
    },
    async loadArticleUploadCache () {
      if (this.isEditMode) return
      try {
        const raw = localStorage.getItem(ARTICLE_UPLOAD_CACHE_KEY)
        if (!raw) return
        const cache = JSON.parse(raw)
        if (cache.activeTab) this.activeTab = cache.activeTab
        if (cache.scopeListToAdd && Array.isArray(cache.scopeListToAdd)) {
          this.scopeListToAdd = cache.scopeListToAdd.map(s => ({
            hospitalName: s.hospitalName || null,
            departmentName: s.departmentName || null
          }))
        }
        if (cache.scopeForm) {
          this.scopeForm.hospitalName = cache.scopeForm.hospitalName || ''
          this.onScopeHospitalChange() // 先加载科室选项
          this.scopeForm.departmentName = cache.scopeForm.departmentName || ''
        }
        if (cache.ruyuanCategory && cache.ruyuanCategory.length > 1) {
          this.ruyuanCategory = cache.ruyuanCategory
          await this.ruyuanCategoryChange(cache.ruyuanCategory)
          if (cache.ruyuanCheckList && cache.ruyuanCheckList.length > 0) {
            this.ruyuanCheckList = cache.ruyuanCheckList.filter(name =>
              this.ruyuanCheckOptions.some(opt => opt.name === name)
            )
          }
        }
        if (cache.robotCategory && cache.robotCategory.length > 1) {
          this.robotCategory = cache.robotCategory
          await this.robotCategoryChange(cache.robotCategory)
          if (cache.robotCheckList && cache.robotCheckList.length > 0) {
            this.robotCheckList = cache.robotCheckList.filter(name =>
              this.robotCheckOptions.some(opt => opt.name === name)
            )
          }
        }
      } catch (e) {
        console.warn('加载宣教选择缓存失败', e)
      }
    },
    async setArticleActive (articleId) {
      const { data: resp } = await this.$http.get('cms/article/active', {
        params: { id: articleId, active: false }
      })
      if (resp.code !== 200) {
        this.$message.error('上架失败: ' + resp.message)
      }
    },
    async bindCategoryAndTags (articleId) {
      let categoryId = null
      const labelCheckIds = []

      if (this.ruyuanCategory && this.ruyuanCategory.length > 1) {
        categoryId = this.ruyuanCategory[1]
        this.ruyuanCheckList.forEach(checked => {
          this.ruyuanCheckOptions.forEach(option => {
            if (checked === option.name) {
              labelCheckIds.push(option.id)
            }
          })
        })
      } else if (this.robotCategory && this.robotCategory.length > 1) {
        categoryId = this.robotCategory[1]
        this.robotCheckList.forEach(checked => {
          this.robotCheckOptions.forEach(option => {
            if (checked === option.name) {
              labelCheckIds.push(option.id)
            }
          })
        })
      }

      if (!categoryId) {
        return
      }

      await this.$http.post('category/binding/article_and_category', null, {
        params: { articleId, categoryId }
      })

      if (labelCheckIds.length > 0) {
        const ids = labelCheckIds.join(',')
        await this.$http.post(`article_category_tag/binding/singleCategory/article_and_category_tag?categoryId=${categoryId}&articleId=${articleId}&tagIdList=${ids}`)
      }
    },
    async bindArticleScopes (articleId) {
      for (const scope of this.scopeListToAdd) {
        const params = { articleId }
        if (scope.hospitalName) {
          params.hospitalName = scope.hospitalName
          if (scope.departmentName) params.departmentName = scope.departmentName
        }
        await this.$http.post('article/scope/save', null, { params })
      }
    },
    async loadHospitalDepartments () {
      const { data: resp } = await this.$http.get('article/scope/hospital_departments')
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.scopeHospitalOptions = resp.data.hospitals || []
      this.scopeDepartmentsByHospital = resp.data.departmentsByHospital || {}
    },
    onScopeHospitalChange () {
      this.scopeForm.departmentName = ''
      this.scopeDepartmentOptions = this.scopeDepartmentsByHospital[this.scopeForm.hospitalName] || []
    },
    addScopeToAdd () {
      const params = {}
      if (this.scopeForm.hospitalName) {
        params.hospitalName = this.scopeForm.hospitalName
        params.departmentName = this.scopeForm.departmentName || null
      } else {
        params.hospitalName = null
        params.departmentName = null
      }
      this.scopeListToAdd.push({ ...params })
      this.saveArticleUploadCache() // 先保存，再清空，以便记住本次选择的医院科室
      this.scopeForm = { hospitalName: '', departmentName: '' }
      this.scopeDepartmentOptions = []
    },
    removeScopeToAdd (index) {
      this.scopeListToAdd.splice(index, 1)
      this.saveArticleUploadCache()
    },
    async ruyuanCategoryChange (value) {
      const { data: resp } = await this.$http.get('article_category_tag/find/category_tag', {
        params: { categoryId: value[1], role: 0 }
      })
      if (resp.code === 200) {
        this.ruyuanCheckOptions = resp.data
        this.ruyuanCheckList = []
      }
      this.saveArticleUploadCache()
    },
    async loadRuyuanCategories () {
      const { data: resp } = await this.$http.get('category/categories', {
        params: { type: 'a', row: 0 }
      })
      if (resp.code === 200) {
        this.ruyuanCategoryOptions = resp.data
      }
    },
    async robotCategoryChange (value) {
      const { data: resp } = await this.$http.get('article_category_tag/find/category_tag', {
        params: { categoryId: value[1], role: 0, showInRobot: true }
      })
      if (resp.code === 200) {
        this.robotCheckOptions = resp.data
        this.robotCheckList = []
      }
      this.saveArticleUploadCache()
    },
    async loadRobotCategories () {
      const { data: resp } = await this.$http.get('category/find/first_category', {
        params: { type: 'a', role: 0, showInRobot: true }
      })
      if (resp.code !== 200) return

      const firstCategories = resp.data || []
      const categoryOptions = []

      for (const firstCat of firstCategories) {
        const { data: secResp } = await this.$http.get('category/find/sec_category', {
          params: { firstId: firstCat.firstId, role: 0, showInRobot: true }
        })

        if (secResp.code === 200 && secResp.data) {
          const children = secResp.data.map(sec => ({
            value: sec.id,
            label: sec.secName
          }))

          categoryOptions.push({
            value: firstCat.firstId,
            label: firstCat.firstName,
            children: children
          })
        }
      }

      this.robotCategoryOptions = categoryOptions
    },
    // 时间格式化工具
    formatDate (val) {
      if (!val) return '-'
      const date = typeof val === 'string' ? new Date(val) : new Date(Number(val))
      if (isNaN(date.getTime())) return '-'
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      const h = date.getHours().toString().padStart(2, '0')
      const min = date.getMinutes().toString().padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}`
    },
    // 视频地址补全工具
    fixVideoUrl (url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      return 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/' + url.replace(/^\//, '')
    },
    onPreview (row) {
      // 判断类型
      if (row.type === '视频') {
        // 训练库视频：videoUrl，康复圈视频：video
        let url = ''
        if (row.source === '训练库') {
          url = row.raw && row.raw.videoUrl
        } else if (row.source === '康复圈') {
          url = row.raw && row.raw.video
        }
        this.previewType = 'video'
        this.previewVideoUrl = this.fixVideoUrl(url || '')
        this.previewTitle = row.title
        this.previewContent = ''
        this.previewVisible = true
      } else if (row.type === '文章') {
        this.previewType = 'article'
        this.previewContent = row.content || ''
        this.previewTitle = row.title
        this.previewVideoUrl = ''
        this.previewVisible = true
      } else {
        this.previewType = ''
        this.previewContent = ''
        this.previewTitle = row.title
        this.previewVideoUrl = ''
        this.previewVisible = true
      }
    },
    onPreviewClose () {
      this.previewType = ''
      this.previewContent = ''
      this.previewTitle = ''
      this.previewVideoUrl = ''
    },
    onSelectJsonFile () {
      this.$refs.jsonFileInput.click()
    },
    onJsonFileChange (event) {
      const file = event.target.files[0]
      if (!file) return

      this.jsonFileName = file.name
      const reader = new FileReader()

      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result)

          if (!Array.isArray(jsonData)) {
            this.$message.error('JSON 格式错误：数据应为数组格式')
            this.jsonImportData = null
            this.jsonFileName = ''
            return
          }

          const isValid = jsonData.every(item =>
            item.hasOwnProperty('药物名称') && item.hasOwnProperty('描述')
          )

          if (!isValid) {
            this.$message.error('JSON 格式错误：每条数据必须包含"药物名称"和"描述"字段')
            this.jsonImportData = null
            this.jsonFileName = ''
            return
          }

          this.jsonImportData = jsonData
          this.$message.success(`成功解析 ${jsonData.length} 条数据`)
        } catch (error) {
          this.$message.error('JSON 文件解析失败：' + error.message)
          this.jsonImportData = null
          this.jsonFileName = ''
        }
      }

      reader.onerror = () => {
        this.$message.error('文件读取失败')
        this.jsonImportData = null
        this.jsonFileName = ''
      }

      reader.readAsText(file)
      event.target.value = ''
    },
    async onBatchImport () {
      if (!this.jsonImportData || this.jsonImportData.length === 0) {
        this.$message.warning('请先选择 JSON 文件')
        return
      }

      const hasCategory = (this.ruyuanCategory && this.ruyuanCategory.length > 1) ||
                         (this.robotCategory && this.robotCategory.length > 1)

      if (!hasCategory) {
        this.$message.warning('请先选择分类（入院宣教或机器人宣教）')
        return
      }

      this.batchImporting = true
      this.batchProgress = {
        current: 0,
        total: this.jsonImportData.length,
        success: 0,
        fail: 0
      }

      for (let i = 0; i < this.jsonImportData.length; i++) {
        const item = this.jsonImportData[i]
        this.batchProgress.current = i + 1

        try {
          if (!item['药物名称'] || !item['描述']) {
            this.batchProgress.fail++
            continue
          }

          const articleData = {
            title: item['药物名称'],
            content: item['描述'],
            robotScript: item['描述'],
            brief: '无',
            author: '动优科技',
            refLink: '',
            contentType: 3 // 录入文章
          }

          const { data: resp } = await this.$http.post('cms/article/add', articleData)

          if (resp.code === 200) {
            const articleId = resp.data.id
            await this.bindCategoryAndTags(articleId)
            await this.bindArticleScopes(articleId)
            await this.setArticleActive(articleId)
            this.batchProgress.success++
          } else {
            this.batchProgress.fail++
          }
        } catch (error) {
          console.error('批量导入错误：', error)
          this.batchProgress.fail++
        }
      }

      this.batchImporting = false
      this.$message({
        message: `批量导入完成！成功 ${this.batchProgress.success} 条，失败 ${this.batchProgress.fail} 条`,
        type: this.batchProgress.fail === 0 ? 'success' : 'warning',
        duration: 5000
      })

      this.jsonImportData = null
      this.jsonFileName = ''
    },
    onSelectWordFile () {
      this.$refs.wordFileInput.click()
    },
    async onWordFileChange (event) {
      const file = event.target.files[0]
      if (!file) return

      const fileName = file.name.replace(/\.docx?$/i, '')

      try {
        this.$message.info('正在解析 Word 文档...')

        const arrayBuffer = await file.arrayBuffer()

        if (!window.mammoth) {
          await this.loadMammoth()
        }

        const result = await window.mammoth.convertToHtml(
          { arrayBuffer: arrayBuffer },
          {
            convertImage: window.mammoth.images.imgElement((image) => {
              return image.read('base64').then(async (imageBuffer) => {
                const blob = this.base64ToBlob(imageBuffer, image.contentType)
                const timestamp = Date.now()
                const ext = image.contentType.split('/')[1] || 'png'
                const file = new File([blob], `word_image_${timestamp}.${ext}`, { type: image.contentType })

                return new Promise((resolve, reject) => {
                  uploadFile(
                    'article/img',
                    file,
                    percent => {},
                    fileUrl => {
                      resolve({ src: fileUrl })
                    },
                    error => {
                      console.error('Word图片上传失败', error)
                      resolve({ src: 'data:' + image.contentType + ';base64,' + imageBuffer })
                    }
                  )
                })
              })
            })
          }
        )

        const htmlContent = result.value
        const textContent = this.extractTextFromHtml(htmlContent)

        this.article.title = fileName
        this.article.robotScript = textContent

        if (this.$refs.myQuillEditor) {
          const quill = this.$refs.myQuillEditor.quill
          quill.deleteText(0, quill.getLength(), 'silent')
          quill.clipboard.dangerouslyPasteHTML(0, htmlContent, 'user')
          this.article.content = quill.root.innerHTML
        } else {
          this.article.content = htmlContent
        }

        this.$message.success('Word 文档导入成功')
      } catch (error) {
        console.error('Word 文档解析失败：', error)
        this.$message.error('Word 文档解析失败：' + error.message)
      }

      event.target.value = ''
    },
    loadMammoth () {
      return new Promise((resolve, reject) => {
        if (window.mammoth) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/mammoth@1.6.0/mammoth.browser.min.js'
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('mammoth 加载失败'))
        document.head.appendChild(script)
      })
    },
    extractTextFromHtml (html) {
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    base64ToBlob (base64, contentType) {
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: contentType })
    },
    onSelectBatchWordFiles () {
      this.$refs.batchWordFileInput.click()
    },
    onBatchWordFileChange (event) {
      const files = Array.from(event.target.files || [])
      if (files.length === 0) return

      this.batchWordFiles = files
      this.$message.success(`已选择 ${files.length} 个 Word 文件`)
      event.target.value = ''
    },
    async onBatchWordImport () {
      if (this.batchWordFiles.length === 0) {
        this.$message.warning('请先选择 Word 文件')
        return
      }

      const hasCategory = (this.ruyuanCategory && this.ruyuanCategory.length > 1) ||
                         (this.robotCategory && this.robotCategory.length > 1)

      if (!hasCategory) {
        this.$message.warning('请先选择分类（入院宣教或机器人宣教）')
        return
      }

      this.batchWordImporting = true
      this.batchWordProgress = {
        current: 0,
        total: this.batchWordFiles.length,
        success: 0,
        fail: 0
      }

      if (!window.mammoth) {
        await this.loadMammoth()
      }

      for (let i = 0; i < this.batchWordFiles.length; i++) {
        const file = this.batchWordFiles[i]
        this.batchWordProgress.current = i + 1

        try {
          const fileName = file.name.replace(/\.docx?$/i, '')
          const arrayBuffer = await file.arrayBuffer()

          const result = await window.mammoth.convertToHtml(
            { arrayBuffer: arrayBuffer },
            {
              convertImage: window.mammoth.images.imgElement((image) => {
                return image.read('base64').then(async (imageBuffer) => {
                  const blob = this.base64ToBlob(imageBuffer, image.contentType)
                  const timestamp = Date.now()
                  const ext = image.contentType.split('/')[1] || 'png'
                  const file = new File([blob], `word_image_${timestamp}.${ext}`, { type: image.contentType })

                  return new Promise((resolve, reject) => {
                    uploadFile(
                      'article/img',
                      file,
                      percent => {},
                      fileUrl => {
                        resolve({ src: fileUrl })
                      },
                      error => {
                        console.error('Word图片上传失败', error)
                        resolve({ src: 'data:' + image.contentType + ';base64,' + imageBuffer })
                      }
                    )
                  })
                })
              })
            }
          )

          const htmlContent = result.value
          const textContent = this.extractTextFromHtml(htmlContent)

          const articleData = {
            title: fileName,
            content: htmlContent,
            robotScript: textContent,
            brief: textContent.substring(0, 100) || '无',
            author: '动优科技',
            refLink: '',
            contentType: 3 // 录入文章
          }

          const { data: resp } = await this.$http.post('cms/article/add', articleData)

          if (resp.code === 200) {
            const articleId = resp.data.id
            await this.bindCategoryAndTags(articleId)
            await this.bindArticleScopes(articleId)
            await this.setArticleActive(articleId)
            this.batchWordProgress.success++
          } else {
            this.batchWordProgress.fail++
          }
        } catch (error) {
          console.error('批量Word导入错误：', error)
          this.batchWordProgress.fail++
        }
      }

      this.batchWordImporting = false
      this.$message({
        message: `批量导入完成！成功 ${this.batchWordProgress.success} 条，失败 ${this.batchWordProgress.fail} 条`,
        type: this.batchWordProgress.fail === 0 ? 'success' : 'warning',
        duration: 5000
      })

      this.batchWordFiles = []
    }
  },
  watch: {
    activeTab () {
      this.saveArticleUploadCache()
    },
    ruyuanCheckList: {
      handler () {
        this.saveArticleUploadCache()
      },
      deep: true
    },
    robotCheckList: {
      handler () {
        this.saveArticleUploadCache()
      },
      deep: true
    },
    scopeForm: {
      handler () {
        this.saveArticleUploadCache()
      },
      deep: true
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    isEditMode () {
      return !!this.id
    },
    filterResults () {
      if (this.filterType === 'all') return this.searchResults
      if (this.filterType === 'krq_article') {
        return this.searchResults.filter(item => item.source === '康复圈' && item.type === '文章')
      }
      if (this.filterType === 'krq_video') {
        return this.searchResults.filter(item => item.source === '康复圈' && item.type === '视频')
      }
      if (this.filterType === 'course_video') {
        return this.searchResults.filter(item => item.source === '训练库' && item.type === '视频')
      }
      return this.searchResults
    }
  },
  async mounted () {
    console.log('this is current quill instance object', this.editor)
    await Promise.all([
      this.loadRuyuanCategories(),
      this.loadRobotCategories(),
      this.loadHospitalDepartments()
    ])
    if (this.isEditMode) {
      this.loadArticleForEdit(this.id)
    } else {
      await this.loadArticleUploadCache()
    }
  }

}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-layout {
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1400px;
  margin-top: 20px;
  align-items: stretch;
}

.editor-wrapper {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.editor {
  width: 375px;
  flex: 1;
  min-height: 600px;
  line-height: 24px;
  .ql-snow {
    background-color: #ffffff;
  }
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 400px;
}

.brief-section {
  flex-shrink: 0;
  margin-bottom: 20px;

  h5 {
    margin: 0 0 10px 0;
  }
}

.brief-input {
  width: 100%;
}

.robot-script-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  h5 {
    margin: 0 0 10px 0;
  }
}

.category-section-top {
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;

  h5 {
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
  }

  .scope-hint {
    margin: 0 0 10px 0;
    font-size: 12px;
    color: #909399;
  }
}

.robot-script-input {
  flex: 1;
  width: 100%;
  display: flex;

  ::v-deep .el-textarea {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-textarea__inner {
    flex: 1;
    resize: none;
  }
}

.ql-editor {
  line-height: 1.7;
}

/* 预览弹窗手机样式 */
.mobile-preview-dialog {
  top: 10vh !important;
  border-radius: 32px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
}

/* 预览弹窗内容区图片自适应，长图可滚动显示 */
::v-deep(.mobile-preview-dialog .el-dialog__body) img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 32px;
}

.el-dialog{
  border-radius: 32px !important;
}

.ellipsis-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5; /* 调整行高 */
  max-height: 3em; /* 2行 x 1.5行高 */
}
/* 限制 Tooltip 宽度并自动换行 */
.long-text-tooltip {
  max-width: 400px;  /* 按需调整 */
  word-wrap: break-word;
  white-space: normal;
}

/* 批量导入区域样式 */
.batch-import-section {
  margin-top: 30px;
  padding: 20px;
  border: 2px dashed #d9ecff;
  border-radius: 8px;
  background: linear-gradient(135deg, #f5f9ff 0%, #e8f4ff 100%);
  width: 900px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.1);
  }

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    h5 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .section-hint {
      font-size: 12px;
      color: #909399;
    }
  }
}

.batch-import-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .control-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .file-info-box {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    flex: 1;

    i {
      font-size: 16px;
      color: #409eff;
    }

    .file-name {
      flex: 1;
      color: #606266;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.batch-progress {
  margin-top: 16px;
  padding: 16px;
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #e4e7ed;

  .progress-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    font-size: 14px;
    color: #606266;

    .progress-detail {
      display: flex;
      gap: 16px;

      .success-count {
        color: #67c23a;
        font-weight: 500;
      }

      .fail-count {
        color: #f56c6c;
        font-weight: 500;
      }
    }
  }
}

.submit-section {
  margin-top: 20px;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 6px;
  width: 900px;
  text-align: center;
}
</style>

<!-- 新增：全局样式，确保.el-dialog圆角生效 -->
<style>
/*
  由于Element UI的.el-dialog弹窗DOM节点挂载在body下，
  scoped样式无法作用于其上，所以需要用全局样式覆盖。
  这样可以确保所有弹窗都带有圆角。
*/
.el-dialog {
  border-radius: 16px !important;
}
</style>
